import React,{useState}from"react";
import{Box,Typography,TextField,InputAdornment,FormControl,Select,MenuItem,IconButton,Menu,Tooltip}from"@mui/material";
import SearchRoundedIcon from"@mui/icons-material/SearchRounded";
import DescriptionOutlinedIcon from"@mui/icons-material/DescriptionOutlined";
import FolderZipOutlinedIcon from"@mui/icons-material/FolderZipOutlined";
import directoryIcon from"../../../static/media/icon/directory.svg";

const ESTADOS=[
  {value:"",label:"Todos los estados"},
  {value:"EMITIDA",label:"Emitida"},
  {value:"AUTORIZADA",label:"Autorizada"},
  {value:"DEVUELTA",label:"Devuelta"},
];

export default function Filter({search,setSearch,desde,setDesde,hasta,setHasta,estado,setEstado,dashboardTheme,disabled=false,canReports=false,onDownloadReport,onDownloadBackup}){
  const[anchorEl,setAnchorEl]=useState(null);
  const open=Boolean(anchorEl);

  const handleOpen=event=>{
    if(disabled)return;
    setAnchorEl(event.currentTarget);
  };

  const handleClose=()=>{
    setAnchorEl(null);
  };

  const handleDownloadReport=()=>{
    handleClose();
    if(typeof onDownloadReport==="function"){
      onDownloadReport();
    }
  };

  const handleDownloadBackup=()=>{
    handleClose();
    if(typeof onDownloadBackup==="function"){
      onDownloadBackup();
    }
  };

  const menuProps={
    disableScrollLock:true,
    PaperProps:{
      sx:{
        mt:.8,
        minWidth:230,
        borderRadius:"12px",
        bgcolor:dashboardTheme.card_background,
        color:dashboardTheme.text_color,
        border:`1px solid ${dashboardTheme.border_color}`,
        boxShadow:"0 8px 28px rgba(0,0,0,0.14)",
        "& .MuiMenuItem-root":{
          minHeight:42,
          fontSize:14,
          fontWeight:600,
        },
      },
    },
    MenuListProps:{
      sx:{py:.6},
    },
  };

  return(
    <Box sx={{...dashboardTheme.tableStyles.toolbar,display:"flex",flexDirection:"column",alignItems:"stretch",gap:1.6}}>
      <Box sx={{display:"flex",alignItems:{xs:"stretch",md:"center"},flexDirection:{xs:"column",md:"row"},gap:1.3}}>
        <Box sx={{display:"flex",alignItems:{xs:"stretch",sm:"center"},flexDirection:{xs:"column",sm:"row"},gap:1.2,flex:1}}>
          <Box sx={{display:"flex",alignItems:{xs:"stretch",sm:"center"},flexDirection:{xs:"column",sm:"row"},gap:1}}>
            <Typography sx={{fontSize:14,fontWeight:700,color:dashboardTheme.text_color,whiteSpace:"nowrap"}}>
              Desde
            </Typography>
            <TextField size="small" type="date" value={desde} disabled={disabled} onChange={event=>setDesde(event.target.value)} inputProps={{max:hasta||undefined}} sx={{width:{xs:"100%",sm:180},...dashboardTheme.inputStyles}}/>
          </Box>

          <Box sx={{display:"flex",alignItems:{xs:"stretch",sm:"center"},flexDirection:{xs:"column",sm:"row"},gap:1}}>
            <Typography sx={{fontSize:14,fontWeight:700,color:dashboardTheme.text_color,whiteSpace:"nowrap"}}>
              Hasta
            </Typography>
            <TextField size="small" type="date" value={hasta} disabled={disabled} onChange={event=>setHasta(event.target.value)} inputProps={{min:desde||undefined}} sx={{width:{xs:"100%",sm:180},...dashboardTheme.inputStyles}}/>
          </Box>

          <FormControl size="small" disabled={disabled} sx={{width:{xs:"100%",sm:210},flexShrink:0,...dashboardTheme.inputStyles}}>
            <Select value={estado} displayEmpty onChange={event=>setEstado(event.target.value)} MenuProps={menuProps} sx={{fontSize:14,fontWeight:600,color:dashboardTheme.text_color,"& .MuiSelect-select":{display:"flex",alignItems:"center"}}}>
              {ESTADOS.map(item=>(
                <MenuItem key={item.value||"todos"} value={item.value}>
                  {item.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {canReports&&(
          <Box sx={{display:"flex",alignItems:"center",justifyContent:{xs:"flex-end",md:"center"},flexShrink:0}}>
            <Tooltip title="Descargas" arrow>
              <span>
                <IconButton disabled={disabled} onClick={handleOpen} sx={{width:42,height:42,borderRadius:"11px",border:`1px solid ${dashboardTheme.border_color}`,bgcolor:dashboardTheme.card_background,"&:hover":{bgcolor:`${dashboardTheme.primary_color}12`,borderColor:dashboardTheme.primary_color},"&.Mui-disabled":{opacity:.45}}}>
                  <Box component="img" src={directoryIcon} alt="Descargas" sx={{width:24,height:24,objectFit:"contain"}}/>
                </IconButton>
              </span>
            </Tooltip>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose} disableScrollLock PaperProps={menuProps.PaperProps} MenuListProps={menuProps.MenuListProps} anchorOrigin={{vertical:"bottom",horizontal:"right"}} transformOrigin={{vertical:"top",horizontal:"right"}}>
              <MenuItem onClick={handleDownloadReport}>
                <DescriptionOutlinedIcon sx={{mr:1.2,fontSize:20,color:dashboardTheme.primary_color}}/>
                Descargar reporte Excel
              </MenuItem>

              <MenuItem onClick={handleDownloadBackup}>
                <FolderZipOutlinedIcon sx={{mr:1.2,fontSize:20,color:dashboardTheme.primary_color}}/>
                Descargar facturas
              </MenuItem>
            </Menu>
          </Box>
        )}
      </Box>

      <TextField fullWidth size="small" placeholder="Buscar por código, número de documento o persona" value={search} disabled={disabled} onChange={event=>setSearch(event.target.value)} InputProps={{startAdornment:<InputAdornment position="start"><SearchRoundedIcon sx={{color:dashboardTheme.theme_mode==="dark"?"rgba(255,255,255,0.62)":"#6b7280"}}/></InputAdornment>}} sx={{...dashboardTheme.inputStyles,"& .MuiInputBase-input::placeholder":{color:dashboardTheme.theme_mode==="dark"?"rgba(255,255,255,0.55)":"#6b7280",opacity:1}}}/>
    </Box>
  );
}